import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ShowcaseMiniEntity } from '../../domain/entities/ShowcaseMiniEntity'
export class ShowcaseMiniModel extends ShowcaseMiniEntity {
  constructor(dataDto: ShowcaseMiniEntity) {
    super()
    mapEntityProperties<ShowcaseMiniEntity>(this, dataDto)
  }
}
